export const DocumentSeriesResetPeriod = {
  YEAR: 'YEAR',
  NEVER: 'NEVER',
};

export const DocumentSeriesResetPeriodList = [
  { value: DocumentSeriesResetPeriod.YEAR, label: 'Évente' },
  { value: DocumentSeriesResetPeriod.NEVER, label: 'Soha' },
];
